import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/thankyou',
      name: 'thankyou',
      component: () => import('./views/ThankYou.vue')
    },
    {
      path: '/offline-enquiries',
      name: 'offline-enquiries',
      component: () => import('./views/OfflineEnquiries.vue')
    },    
    {
      path: '/',
      name: 'login',
      component: () => import('./views/Login.vue')

    }
  ]
})
